import React from 'react';
import styled from 'styled-components';
import { Users, Eye } from 'lucide-react';

interface RoleIndicatorChipProps {
  permissionLevel?: number;
  isSupervisor?: boolean;
}

const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: var(--hover-background);
  border-radius: 16px;
  font-size: 13px;
  color: var(--text-secondary);
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  color: var(--text-tertiary);
`;

const RoleIndicatorChip: React.FC<RoleIndicatorChipProps> = ({
  permissionLevel,
  isSupervisor
}) => {
  const isSystemAdmin = permissionLevel === 1;
  const showAllLeads = isSystemAdmin || isSupervisor;

  const getMessage = () => {
    if (isSystemAdmin) return 'כל הלידים במערכת';
    if (isSupervisor) return 'כל הלידים (מפקח)';
    return 'הלידים שלי';
  };

  return (
    <Chip>
      <IconWrapper>
        {showAllLeads ? <Users size={14} /> : <Eye size={14} />}
      </IconWrapper>
      {getMessage()}
    </Chip>
  );
};

export default RoleIndicatorChip;
